"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = require("prop-types");
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
var _modalDecorator = _interopRequireDefault(require("../../../../../hocs/modalDecorator"));
var _modalActions = require("../../../../../redux/actions/modalActions");
require("./FuturesTradingConfirmationModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('futures-trading-confirmation');
var FuturesTradingConfirmationModal = function FuturesTradingConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Futures Trading'),
    close: close,
    footer: {
      buttonText: t('OK'),
      onClick: close
    },
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
    className: "confirm-message-one"
  }, t('Futures trading has been enabled.')), /*#__PURE__*/_react["default"].createElement("p", null, t('You can now trade Futures on the instruments that have it enabled.'))));
};
FuturesTradingConfirmationModal.propTypes = {
  close: _propTypes.func.isRequired,
  isOpen: _propTypes.bool.isRequired
};
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.FUTURES_CONFIRM
})(FuturesTradingConfirmationModal);